import "./sidebar.css";
import { BiX } from "react-icons/bi";
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { GiHamburgerMenu } from "react-icons/gi";
import { FaRegFolderClosed } from "react-icons/fa6";
import { Link, useLocation } from "react-router-dom";
import { FiShoppingBag, FiBookOpen } from "react-icons/fi";
import { PiChartPieSliceBold, PiUserSquareDuotone } from "react-icons/pi";
import { useAuth } from "../../Context/AuthContext";

const Sidebar = ({ toggleHb, active }) => {

  const { logout } = useAuth();

  const location = useLocation();

  let pathname = location.pathname;

  pathname = pathname.split("/")[1];

  return (
    <div className="item1">
      {active ? (
        <BiX onClick={toggleHb} className="humberger-menu closeMenu" />
      ) : (
        <GiHamburgerMenu onClick={toggleHb} className="humberger-menu" />
      )}
      <nav className="sidebar_nav">
        <div className="logo">
          <Link to={"/"} className="logo-link">
            <div className="d-flex gap-2">
              <img src="/images/logo.png" alt="icon" />
              <h6>Nishant</h6>
            </div>
          </Link>
        </div>

        <ul className="ps-3">
          {/* <div className="d-flex gap-2">
                        <p>Favorites</p>
                        <h1>Recently</h1>
                    </div>
                    <li onClick={toggleHb} className={pathname === "" && "activUrl"}> {" "}
                        <Link to={"/"} className="nav-anchor">  <GoDotFill className="fas activUrly" style={{ color: '#d9d9d9', height: '15px' }} />{" "}<span className="nav-item">Overview</span> </Link>
                    </li>

                    <li onClick={toggleHb} className={pathname === "studentinformation" && "activUrl"}>   {" "}
                        <Link to={"studentinformation"} className="nav-anchor">
                            <GoDotFill className="fas" style={{ color: '#d9d9d9', height: '15px' }} />{" "}
                            <span className="nav-item">Projects </span>
                        </Link>
                    </li> */}
          <div className="pt-2">
            <p>Dashboards</p>
          </div>

          <li
            onClick={toggleHb}
            className={pathname === "dashboard" && "activUrl"}
          >
            {" "}
            <Link to={"dashboard"} className="nav-anchor">
              <PiChartPieSliceBold className="fas" />{" "}
              <span className="nav-item">Dashboard</span>
            </Link>
          </li>

          <li
            onClick={toggleHb}
            className={pathname === "researches" && "activUrl"}
          >
            {" "}
            <Link to={"researches"} className="nav-anchor">
              <FiShoppingBag className="fas" />{" "}
              <span className="nav-item">Researches</span>
            </Link>
          </li>
          
          <li
            onClick={toggleHb}
            className={pathname === "applications" && "activUrl"}
          >
            {" "}
            <Link to={"applications"} className="nav-anchor">
              <FiShoppingBag className="fas" />{" "}
              <span className="nav-item">Applications</span>
            </Link>
          </li>

          <li
            onClick={toggleHb}
            className={pathname === "forms" && "activUrl"}
          >
            {" "}
            <Link to={"forms"} className="nav-anchor">
              <FaRegFolderClosed className="fas" />{" "}
              <span className="nav-item">Forms</span>
            </Link>
          </li>
          
          <li
            onClick={toggleHb}
            className={pathname === "profile" && "activUrl"}
          >
            {" "}
            <Link to={"profile"} className="nav-anchor">
              <FaRegFolderClosed className="fas" />{" "}
              <span className="nav-item">Profile</span>
            </Link>
          </li>

          <li
            onClick={toggleHb}
            className={pathname === "support" && "activUrl"}
          >
            {" "}
            <Link to={"push-notification"} className="nav-anchor">
              <FiBookOpen className="fas" />{" "}
              <span className="nav-item">Push Notifications</span>
            </Link>
          </li>
          
          <li
            onClick={toggleHb}
            className={pathname === "support" && "activUrl"}
          >
            {" "}
            <Link to={"support"} className="nav-anchor">
              <FiBookOpen className="fas" />{" "}
              <span className="nav-item">Support</span>
            </Link>
          </li>

          <li
            onClick={logout}
            // className={pathname === "notification" && "activUrl"}
          >
            {" "}
            <div>
              <PiUserSquareDuotone className="fas" />{" "}
              <span className="nav-item">Logout</span>
            </div>
          </li>

          {/* <div className="pt-2">
                        <p>Pages</p>
                    </div>

                    <li onClick={toggleSubMenu} className={pathname === "support" ? "activUrlPage" : ""}>
                        <Link to={"support"} className="nav-anchor">
                            <IoIosArrowForward className="text-secondary fw-lighter" />  <PiUserSquareDuotone className="fas" />{" "}
                            <span className="nav-item">User Profile</span>
                        </Link>

                        <ul className={`submenu ${isSubMenuOpen ? 'open' : ''}`}>
                            <li> <Link to={"overview"}>   <span className="nav-item">Overview</span> </Link></li>
                            <li> <Link to={"projects"}>  <span className="nav-item">Projects</span> </Link></li>
                            <li> <Link to={"Campaigns"}><span className="nav-item">Campaigns</span> </Link></li>
                            <li> <Link to={"documents"}> <span className="nav-item">Documents</span> </Link></li>
                            <li> <Link to={"followers"}> <span className="nav-item">Followers</span> </Link></li>
                        </ul>
                    </li>


                    <li onClick={toggleHb} className={pathname === "blog" && "activUrl"}>    {" "}
                        <Link to={"blog"} className="nav-anchor">
                            <IoIosArrowForward className="text-secondary fw-lighter" />      <ImProfile className="fas" />{" "} <span className="nav-item">Account</span></Link>
                    </li>

                    <li onClick={toggleHb} className={pathname === "planbillings" && "activUrl"} > {" "}
                        <Link to={"planbillings"} className="nav-anchor">  <IoIosArrowForward className="text-secondary fw-lighter" />  <FaUsers className="fas" />{" "}
                            <span className="nav-item">Corporate</span>
                        </Link>
                    </li>

                    <li onClick={toggleHb} className={pathname === "mypayment" && "activUrl"} > {" "}
                        <Link to={"mypayment"} className="nav-anchor">
                            <IoIosArrowForward className="text-secondary fw-lighter" />  <RiPagesLine className="fas" />{" "}
                            <span className="nav-item"> Blog</span>
                        </Link>
                    </li> */}

          {/* <li onClick={toggleHb} className={pathname === "universities" && "activUrl"} >{" "}
                        <Link to={"universities"} className="nav-anchor">
                        <IoIosArrowForward className="text-secondary fw-lighter"/> < PiChatsCircle className="fas" />{" "}
                            <span className="nav-item">Social</span>
                        </Link>
                    </li> */}
        </ul>
      </nav>
    </div>
  );
};
export default Sidebar;
